import { Steps, StepsProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { CheckDotWrapper, StepsContainer } from './ServiceSteps.styles';
import { SvgIcon } from 'lib/components/SvgIcon/SvgIcon';

export interface ServiceStepsProps {
  currentStep: number;
}

const customDot: StepsProps['progressDot'] = (dot, { status }) => {
  if (status === 'finish') {
    return (
      <CheckDotWrapper
        style={{
          backgroundColor: 'rgba(0, 0, 0, 0.12)',
          borderRadius: '50%',
          width: 16,
          height: 16,
          margin: 0,
          padding: 0,
        }}
      >
        <SvgIcon name="check" />
      </CheckDotWrapper>
    );
  }

  return dot;
};

export const ServiceSteps = ({ currentStep }: ServiceStepsProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <StepsContainer progressDot={customDot} current={currentStep} responsive={false}>
      <Steps.Step title={t('service.steps.identifyDevice')} />
      <Steps.Step title={t('service.steps.describeIssue')} />
      <Steps.Step title={t('service.steps.details')} />
      <Steps.Step title={t('service.steps.reviewSubmit')} />
    </StepsContainer>
  );
};
